exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[data-v-b425c608] {\n    display: inline-block;\n    width: 70%;\n}\n", ""]);

// exports
